import { config } from 'api';
import errorHandler from 'lib/utils/errorHandler';

class CitrusAdTracker {
  citrusAd = null;

  loadAPI = () => new Promise((resolve, reject) => {
    if (window.CitrusAd) {
      resolve();
      return;
    }

    let citrusAdScript = document.getElementById('citrusad-api');
    if (!citrusAdScript) {
      citrusAdScript = document.createElement('script');
      citrusAdScript.id = 'citrusad-api';
      citrusAdScript.src = config.citrusScriptUrl;
      citrusAdScript.defer = true;

      document.body.appendChild(citrusAdScript);
    }

    citrusAdScript.addEventListener('load', () => resolve());
    citrusAdScript.addEventListener('error', () => reject());
  });

  initAPI = () => this.loadAPI().then(() => {
    if (this.citrusAd) {
      return;
    }

    if (window.CitrusAd) {
      this.citrusAd = window.CitrusAd.init(
        config.citrusApiUrl,
        { disableTracking: false }
      );
    }

    if (!this.citrusAd) {
      throw new Error('CitrusAd API was not loaded');
    }
  });

  reportClick = ({ adId, callback }) => this.initAPI()
    .then(() => this.citrusAd.reportClick(adId), errorHandler)
    .then(() => {
      if (typeof callback === 'function') {
        callback();
      }
    });

  reportImpression = ({ adId }) => this.initAPI()
    .then(() => this.citrusAd.reportImpression(adId), errorHandler);
}

const citrusAdTracker = typeof window !== 'undefined' ? new CitrusAdTracker() : null;

export default citrusAdTracker;
